import { AutogenLayoutStateTaxDetailTable } from "./autogen/AutogenLayoutStateTaxDetailTable";

export class StateTaxDetailTable extends AutogenLayoutStateTaxDetailTable {
   
}
